export const serviceAreas = [
  { id: 1, name: 'Marin County', state: 'CA', order: 1, active: true },
  { id: 2, name: 'Napa County', state: 'CA', order: 2, active: true },
  { id: 3, name: 'Sonoma County', state: 'CA', order: 3, active: true },
  { id: 4, name: 'Lake County', state: 'CA', order: 4, active: true },
  { id: 5, name: 'Bodega Bay', state: 'CA', order: 5, active: true },
];